import { c as _c } from "react/compiler-runtime";
import { fileInputAcceptTypes, FileSelectorModal, FileSelectorModalProps, FileSourceEnum, FileTypeEnum, FileDropZone, FileDropZoneProps } from '@systemeio/file-manager';
import { ComponentProps, PropsWithChildren, useRef, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
interface DropZoneProps extends Pick<FileDropZoneProps, 'icon' | 'label' | 'acceptTypes' | 'variant' | 'error' | 'isPreFetching' | 'disabled' | 'className' | 'dropZoneClassName' | 'labelClassName'> {}
type ImageCropperModalProps = NonNullable<FileSelectorModalProps['fileUploaderModalProps']>['imageCropperModalProps'];
export interface Props extends PropsWithChildren, DropZoneProps {
  source: FileSourceEnum;
  imageCropperModalProps?: ImageCropperModalProps;
  showDropZone?: boolean;
  statusIcon?: React.ReactNode;
  isSuccess?: boolean;
  onSelect: ComponentProps<typeof FileSelectorModal>['onSelect'];
}
const allowedTypes = [FileTypeEnum.Image, FileTypeEnum.ImageOther];
const initialSearchFilters = {
  name: '',
  source: [],
  type: allowedTypes
};
export const ImageUploader = t0 => {
  const $ = _c(32);
  const {
    icon,
    label,
    variant,
    error,
    isPreFetching,
    disabled,
    children,
    showDropZone: t1,
    className,
    dropZoneClassName,
    labelClassName,
    source,
    imageCropperModalProps,
    statusIcon,
    isSuccess,
    onSelect
  } = t0;
  const showDropZone = t1 === undefined ? true : t1;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const uploaderRef = useRef(undefined) as NonNullable<FileSelectorModalProps['fileUploaderModalProps']>['uploaderRef'];
  const fileSelectorRef = useRef(undefined) as FileSelectorModalProps['fileSelectorRef'];
  let t2;
  if ($[0] !== children || $[1] !== className || $[2] !== disabled || $[3] !== dropZoneClassName || $[4] !== error || $[5] !== icon || $[6] !== isPreFetching || $[7] !== isSuccess || $[8] !== label || $[9] !== labelClassName || $[10] !== showDropZone || $[11] !== statusIcon || $[12] !== t || $[13] !== variant) {
    t2 = showDropZone && <FileDropZone icon={icon} label={label ?? t("global.select_image")} acceptTypes={fileInputAcceptTypes.image} variant={variant} error={error} isPreFetching={isPreFetching} disabled={disabled} className={className} dropZoneClassName={twMerge(dropZoneClassName, statusIcon && "relative", isSuccess && "border-green border-solid hover:border-green")} labelClassName={labelClassName} openNativeWindow={false} onClick={() => {
      setOpened(true);
    }} onSelect={files => {
      setOpened(true);
      setTimeout(() => {
        fileSelectorRef?.current?.setFileUploadModalOpen(true);
        uploaderRef?.current?.addFilesToWaitingUpload(files);
      });
    }}>{statusIcon && <div className="absolute right-2 top-2">{statusIcon}</div>}{children}</FileDropZone>;
    $[0] = children;
    $[1] = className;
    $[2] = disabled;
    $[3] = dropZoneClassName;
    $[4] = error;
    $[5] = icon;
    $[6] = isPreFetching;
    $[7] = isSuccess;
    $[8] = label;
    $[9] = labelClassName;
    $[10] = showDropZone;
    $[11] = statusIcon;
    $[12] = t;
    $[13] = variant;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  const t3 = imageCropperModalProps?.allowSwitchingCroppingShape;
  const t4 = imageCropperModalProps?.isRounded;
  const t5 = imageCropperModalProps?.imageCropperProps?.aspectRatio ?? NaN;
  let t6;
  if ($[15] !== t5) {
    t6 = {
      aspectRatio: t5
    };
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t3 || $[18] !== t4 || $[19] !== t6) {
    t7 = {
      uploaderRef,
      imageCropperModalProps: {
        allowSwitchingCroppingShape: t3,
        isRounded: t4,
        imageCropperProps: t6
      }
    };
    $[17] = t3;
    $[18] = t4;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== onSelect) {
    t8 = file => {
      setOpened(false);
      onSelect(file);
    };
    $[21] = onSelect;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setOpened(false);
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== opened || $[25] !== source || $[26] !== t7 || $[27] !== t8) {
    t10 = <FileSelectorModal opened={opened} uploadingFromSource={source} fileSelectorRef={fileSelectorRef} disabledFileTypeSelect={true} initialSearchFilters={initialSearchFilters} fileUploaderModalProps={t7} onSelect={t8} onClose={t9} />;
    $[24] = opened;
    $[25] = source;
    $[26] = t7;
    $[27] = t8;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t2) {
    t11 = <>{t2}{t10}</>;
    $[29] = t10;
    $[30] = t2;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};